import EventBus, { AppEvents } from '../core/EventBus.js';
import { initiativesStore } from './initiativesStore.js';

// Initialize bridge only once
let initialized = false;

export function initInitiativesBridge() {
  if (initialized) return;
  initialized = true;

  // Seed items from InitiativeService or AppState
  try {
    const svc = window.InitiativeService;
    if (svc && Array.isArray(svc.initiatives)) {
      initiativesStore.setItems(svc.initiatives);
    } else if (window.AppState?.getState) {
      const arr = window.AppState.getState('initiatives') || [];
      if (Array.isArray(arr)) initiativesStore.setItems(arr);
    }
  } catch (_) {}

  // Listen to domain events and update the slice
  EventBus.on(AppEvents.INITIATIVE_ADDED, (item) => {
    if (item) initiativesStore.addItem(item);
  });
  EventBus.on(AppEvents.INITIATIVE_UPDATED, (item) => {
    if (item?.id) initiativesStore.updateItem(item.id, item);
  });
  EventBus.on(AppEvents.INITIATIVE_DELETED, (item) => {
    if (item?.id) initiativesStore.removeItem(item.id);
  });
  EventBus.on(AppEvents.INITIATIVES_SAVED, ({ count }) => {
    // Optionally resync from service to ensure consistency
    try {
      const svc = window.InitiativeService;
      if (svc && Array.isArray(svc.initiatives)) initiativesStore.setItems(svc.initiatives);
    } catch(_) {}
  });
}

// Auto-init in dev for convenience
if (import.meta.env?.DEV) {
  try { initInitiativesBridge(); } catch (_) {}
}
